import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    alertContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: '100%',
        minHeight: 0,
        gap: 2
    },
    divider: {
        height: '3px',
    }
}))